import { render, staticRenderFns } from "./CategoryMenu.vue?vue&type=template&id=e8b61580&scoped=true&"
import script from "./CategoryMenu.vue?vue&type=script&lang=js&"
export * from "./CategoryMenu.vue?vue&type=script&lang=js&"
import style0 from "./CategoryMenu.vue?vue&type=style&index=0&id=e8b61580&prod&lang=scss&scoped=true&"
import style1 from "./CategoryMenu.vue?vue&type=style&index=1&id=e8b61580&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8b61580",
  null
  
)

export default component.exports